import type { FundListBlock as Block } from './types'
import { BlockShell } from './BlockShell'
import type { BlockAction } from './BlockActionsMenu'

interface Props {
  block: Block
  selected: boolean
  frozen: boolean
  animate: boolean
  actions: BlockAction[]
  onToggleSelect: (id: string) => void
}

export function FundListBlockView({ block, ...rest }: Props) {
  return (
    <BlockShell blockId={block.id} slug={block.slug} {...rest}>
      {block.label ? <h4 className="text-sm font-semibold mb-1">{block.label}</h4> : null}
      <ul className="list-disc pl-6 text-sm">
        {block.funds.map((f, i) => (
          <li key={`${block.id}-${i}`}>
            <span className="font-medium">{f.name || 'Unnamed'}</span>
            {f.type ? <span className="text-muted-foreground"> — {f.type}</span> : null}
          </li>
        ))}
      </ul>
    </BlockShell>
  )
}
